import * as React from 'react';
import { Form, Tabs, Tab } from 'react-bootstrap'
import { useImmer } from 'use-immer';
import * as _ from 'lodash';
import {  AxiosInstance } from '../../../utils/RequestMethods';
import ButtonLoading from '../../../components/ButtonLoading/ButtonLoading';
import config from '../../../constants/config';
import { CompanyT } from '../../../types/Company';
import { stringLitArray } from '../../../utils/utilsT';
import NumberFormatValidate from '../../../components/NumberFormatValidate';
import MailServerTest from './MailServerTest';

export interface IMailServerTabProps {
    company: CompanyT
    updateCompany(company: CompanyT): void
}

const SMTPSecureT = stringLitArray(['', 'ssl', 'tls']);
export type SMTPSecureTStrings = (typeof SMTPSecureT)[number];
export const OptionsSMTPSecure = {
    '': '',
    'ssl': "SSL",
    'tls': 'TLS',
}


interface MailServerT {
    host: string
    username: string
    password?: string
    port: number
    auth: boolean
    secure: SMTPSecureTStrings
}


const initFields: MailServerT = {
    host: "",
    username: "",
    password: "",
    port: 587,
    auth: true,
    secure: "tls"
}
const TextRequired = (props) => {
    return (
        <><strong className="text-danger">*</strong></>
    )
}

const MailServerTab: React.FC<IMailServerTabProps> = ({ company, updateCompany }) => {
    // const [dirty, setDirty] = React.useState({})
    const [dirty, setDirty] = useImmer({})
    const [fields, setFields] = React.useState(initFields)
    const [validated, setValidated] = React.useState(false)
    const form = React.useRef(null)




    React.useEffect(() => {

        if (company.mailServer) {
            setFields(darft => {
                darft = { ...fields, ...company.mailServer }
                return darft
            })
        }
    }, [])

    /**
     *
     * @param key
     * @param value
     */
    const onChangeFields = (key, value) => {
        if (value == undefined) {
            value = ""
        }
        setDirty(draft => {
            draft[key] = value
        })
    }

    /**
     *
     */
    const submitSaveCompany = async (): Promise<string> => {
        let params = {
            mailServer: { ...dirty }
        }

        return await saveCompany(params)
    }

    /**
     *
     * @param params
     */
    const saveCompany = async (params): Promise<string> => {
        if (!params) {
            params = {}
        }
        try {
            let res = await AxiosInstance.post(`${config.url.companies}/${company.id}`, params)
            if (res && res.data) {
                console.log(company, res)
                updateCompany(res.data)
                return 'Mail Server saved.'
            }
        } catch (error) {

            throw new Error(error)

        }
    }

    const getLabelAuth = (): JSX.Element => {
        const isChecked = (dirty && _.has(dirty, "auth")) ? dirty['auth'] : fields.auth
        if (isChecked) {
            return (
                <span>ON</span>
            )
        } else {
            return (
                <span>OFF</span>
            )
        }
    }

    return (
        <div>
            <Tabs
                defaultActiveKey='general'
                id='MailServerTabs'>
                <Tab
                    eventKey='general'
                    title='General'>
                    <h3>Mail Server</h3>
                    <Form
                        // onSubmit={handleSubmit}
                        noValidate
                        ref={form}
                        validated={validated}>

                        <Form.Group>
                            <Form.Label>SMTP Host</Form.Label>
                            <Form.Control
                                className='input-material'
                                value={`${dirty && _.has(dirty, "host") ? dirty['host'] : fields.host}`}
                                onChange={(event) => {
                                    onChangeFields("host", event.target.value)
                                }}
                            // required={true}
                            />

                        </Form.Group>


                        <Form.Group>
                            <Form.Label>Encryption</Form.Label>

                            <Form.Control
                                as='select'

                                className='input-material'
                                value={`${dirty && _.has(dirty, "secure") ? dirty['secure'] : fields.secure}`}
                                onChange={(event: any) => {
                                    onChangeFields("secure", event.target.value)


                                }}
                                placeholder='Payment Method'>
                                {Object.keys(OptionsSMTPSecure).map((key, index) => {
                                    return (
                                        <option value={key} key={index}>{OptionsSMTPSecure[key]}</option>
                                    )
                                })}

                            </Form.Control>

                        </Form.Group>
                        <Form.Group>
                            <Form.Label>SMTP Port</Form.Label>
                            <NumberFormatValidate
                                customInput={Form.Control}
                                className="input-material"
                                type="text"
                                defaultValue={`${dirty && _.has(dirty, "port") ? dirty['port'] : fields.port}`}
                                value={`${dirty && _.has(dirty, "port") ? dirty['port'] : fields.port}`}
                                onValueChange={(values) => {
                                    const { formattedValue, value, floatValue } = values;
                                    onChangeFields('port', floatValue)
                                }}
                                mask=""

                            />


                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Authentication</Form.Label>
                            <Form.Check
                                id="custom-switch-auth"
                                type="switch"
                                checked={dirty && _.has(dirty, "auth") ? dirty['auth'] : fields.auth}
                                // value={`${dirty && dirty.hasOwnProperty("auth") ? dirty['auth'] : fields.auth}`}
                                onChange={(event) => {
                                    const isChecked = (dirty && _.has(dirty, "auth")) ? dirty['auth'] : fields.auth
                                    onChangeFields("auth", !isChecked)

                                }}

                                label={getLabelAuth()}
                            />

                        </Form.Group>
                        <Form.Group>
                            <Form.Label>SMTP Username</Form.Label>
                            <Form.Control
                                className='input-material'
                                value={`${dirty && _.has(dirty, "username") ? dirty['username'] : fields.username}`}
                                onChange={(event) => {
                                    onChangeFields("username", event.target.value)

                                }}
                            //required={true}
                            />

                        </Form.Group>
                        <Form.Group>
                            <Form.Label>SMTP Password</Form.Label>
                            <Form.Control
                                type="password"
                                className='input-material'
                                value={`${dirty && _.has(dirty, "password") ? dirty['password'] : fields.password}`}
                                onChange={(event) => {
                                    onChangeFields("password", event.target.value)
                                }}
                            // required={true}
                            />

                        </Form.Group>
                        <ButtonLoading
                            // id="submit-button-s"
                            // disabled={true}
                            className="btn-primary"
                            onClickFetching={async (e): Promise<string> => {
                                //e.stopPropagation()
                                return await submitSaveCompany()
                            }}
                        >
                            Save </ButtonLoading>
                    </Form>
                </Tab>
                <Tab
                    eventKey='emailTest'
                    title='Email Test'>
                    <MailServerTest company={company} />
                </Tab>
            </Tabs>

        </div>

    );
}

export default MailServerTab;
export { MailServerTab };
